import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

function App() {
	return (
		<div className="App motherskyImage">
			<Router>
				<Routes>
					<Route path="/" element={<Home /> }/>
				</Routes>
			</Router>
			<p className="copyright">&copy; {new Date().getFullYear()} mother sky</p>
		</div>
	);
}

export default App;
